import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { MessageService } from 'primeng/api';
import { primeNgPreset } from '../styles/theme/primengprest';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import localeEn from '@angular/common/locales/en';

// Register locale data for Angular date/number pipes
registerLocaleData(localeAr);
registerLocaleData(localeEn);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([
      // Add interceptors here
      tokenInterceptor,
      errorInterceptor
    ])),
    importProvidersFrom(
      [BrowserModule]
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: primeNgPreset,
        options: {
          darkModeSelector: false || 'none',
          rtl: false // Will be updated dynamically by LanguageService
        }
      }
    }),
    MessageService
  ]
};
